import { userInformationStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsUserInformation";
import { css } from "styled-components";

Object.assign(userInformationStyles, {
    ...userInformationStyles,
    userInformationTitle: {
        css: css`
            display: none;
        `,
    },
    userInformationGridItem: {
        width: 12,
        css: css`
            label {
                font-size: 16px;
            }
        `,
    },
});
